export type NsfwVerificationType = "yoti";

export enum EVENTS {
  SENSITIVE_CONTENT_GATE_REQUEST = "SENSITIVE_CONTENT_GATE_REQUEST",
  AGE_VERIFICATION_STATUS_CHANGED = "AGE_VERIFICATION_STATUS_CHANGED",
}

export interface GateRequestPayload {
  verificationType: NsfwVerificationType;
  onResult: (verified: boolean) => void;
}
